export const CREATE_SALESFORCE_CONNECTION_REQUEST = "CREATE_SALESFORCE_CONNECTION_REQUEST";
export const CREATE_SALESFORCE_CONNECTION_SUCCESS = "CREATE_SALESFORCE_CONNECTION_SUCCESS";
export const CREATE_SALESFORCE_CONNECTION_FAILURE = "CREATE_SALESFORCE_CONNECTION_FAILURE";

export const START_SALESFORCE_OAUTH_REQUEST = "START_SALESFORCE_OAUTH_REQUEST";
export const START_SALESFORCE_OAUTH_SUCCESS = "START_SALESFORCE_OAUTH_SUCCESS";
export const START_SALESFORCE_OAUTH_FAILURE = "START_SALESFORCE_OAUTH_FAILURE";

export const GET_SALESFORCE_CONNECTION_REQUEST = "GET_SALESFORCE_CONNECTION_REQUEST";
export const GET_SALESFORCE_CONNECTION_SUCCESS = "GET_SALESFORCE_CONNECTION_SUCCESS";
export const GET_SALESFORCE_CONNECTION_FAILURE = "GET_SALESFORCE_CONNECTION_FAILURE";

export const UPDATE_SALESFORCE_CONNECTION_REQUEST = "UPDATE_SALESFORCE_CONNECTION_REQUEST";
export const UPDATE_SALESFORCE_CONNECTION_SUCCESS = "UPDATE_SALESFORCE_CONNECTION_SUCCESS";
export const UPDATE_SALESFORCE_CONNECTION_FAILURE = "UPDATE_SALESFORCE_CONNECTION_FAILURE";

export const DELETE_SALESFORCE_CONNECTION_REQUEST = "DELETE_SALESFORCE_CONNECTION_REQUEST";
export const DELETE_SALESFORCE_CONNECTION_SUCCESS = "DELETE_SALESFORCE_CONNECTION_SUCCESS";
export const DELETE_SALESFORCE_CONNECTION_FAILURE = "DELETE_SALESFORCE_CONNECTION_FAILURE";

export const GET_SALESFORCE_OBJECTS_REQUEST = "GET_SALESFORCE_OBJECTS_REQUEST";
export const GET_SALESFORCE_OBJECTS_SUCCESS = "GET_SALESFORCE_OBJECTS_SUCCESS";
export const GET_SALESFORCE_OBJECTS_FAILURE = "GET_SALESFORCE_OBJECTS_FAILURE";

export const GET_SALESFORCE_OBJECT_DESCRIBE_REQUEST = "GET_SALESFORCE_OBJECT_DESCRIBE_REQUEST";
export const GET_SALESFORCE_OBJECT_DESCRIBE_SUCCESS = "GET_SALESFORCE_OBJECT_DESCRIBE_SUCCESS";
export const GET_SALESFORCE_OBJECT_DESCRIBE_FAILURE = "GET_SALESFORCE_OBJECT_DESCRIBE_FAILURE";

export const GET_SALESFORCE_OBJECT_PREVIEW_REQUEST = "GET_SALESFORCE_OBJECT_PREVIEW_REQUEST";
export const GET_SALESFORCE_OBJECT_PREVIEW_SUCCESS = "GET_SALESFORCE_OBJECT_PREVIEW_SUCCESS";
export const GET_SALESFORCE_OBJECT_PREVIEW_FAILURE = "GET_SALESFORCE_OBJECT_PREVIEW_FAILURE";

export const createSalesforceConnectionRequest = (connection) => ({
    type: CREATE_SALESFORCE_CONNECTION_REQUEST,
    params: {
        connection
    }
});

export const createSalesforceConnectionSuccess = (connection) => ({
    type: CREATE_SALESFORCE_CONNECTION_SUCCESS,
    payload: {
        connection
    }
});

export const createSalesforceConnectionFailure = (error) => ({
    type: CREATE_SALESFORCE_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const startSalesforceOAuthRequest = (connectionId, returnUrl) => ({
    type: START_SALESFORCE_OAUTH_REQUEST,
    params: {
        connectionId,
        returnUrl
    }
});

export const startSalesforceOAuthSuccess = (result) => ({
    type: START_SALESFORCE_OAUTH_SUCCESS,
    payload: {
        result
    }
});

export const startSalesforceOAuthFailure = (error) => ({
    type: START_SALESFORCE_OAUTH_FAILURE,
    payload: {
        error
    }
});

export const getSalesforceConnectionRequest = (connectionId) => ({
    type: GET_SALESFORCE_CONNECTION_REQUEST,
    params: {
        connectionId
    }
});

export const getSalesforceConnectionSuccess = (connection) => ({
    type: GET_SALESFORCE_CONNECTION_SUCCESS,
    payload: {
        connection
    }
});

export const getSalesforceConnectionFailure = (error) => ({
    type: GET_SALESFORCE_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const updateSalesforceConnectionRequest = (connectionId, updatedConnection) => ({
    type: UPDATE_SALESFORCE_CONNECTION_REQUEST,
    params: {
        connectionId,
        updatedConnection
    }
});

export const updateSalesforceConnectionSuccess = (connection) => ({
    type: UPDATE_SALESFORCE_CONNECTION_SUCCESS,
    payload: {
        connection
    }
});

export const updateSalesforceConnectionFailure = (error) => ({
    type: UPDATE_SALESFORCE_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const deleteSalesforceConnectionRequest = (connectionId) => ({
    type: DELETE_SALESFORCE_CONNECTION_REQUEST,
    params: {
        connectionId
    }
});

export const deleteSalesforceConnectionSuccess = (connectionId) => ({
    type: DELETE_SALESFORCE_CONNECTION_SUCCESS,
    payload: {
        connectionId
    }
});

export const deleteSalesforceConnectionFailure = (error) => ({
    type: DELETE_SALESFORCE_CONNECTION_FAILURE,
    payload: {
        error
    }
});

export const getSalesforceObjectsRequest = (connectionId) => ({
    type: GET_SALESFORCE_OBJECTS_REQUEST,
    params: {
        connectionId
    }
});

export const getSalesforceObjectsSuccess = (objects) => ({
    type: GET_SALESFORCE_OBJECTS_SUCCESS,
    payload: {
        objects
    }
});

export const getSalesforceObjectsFailure = (error) => ({
    type: GET_SALESFORCE_OBJECTS_FAILURE,
    payload: {
        error
    }
});

export const getSalesforceObjectDescribeRequest = (connectionId, objectName) => ({
    type: GET_SALESFORCE_OBJECT_DESCRIBE_REQUEST,
    params: {
        connectionId,
        objectName
    }
});

export const getSalesforceObjectDescribeSuccess = (describe) => ({
    type: GET_SALESFORCE_OBJECT_DESCRIBE_SUCCESS,
    payload: {
        describe
    }
});

export const getSalesforceObjectDescribeFailure = (error) => ({
    type: GET_SALESFORCE_OBJECT_DESCRIBE_FAILURE,
    payload: {
        error
    }
});

export const getSalesforceObjectPreviewRequest = (connectionId, objectName, fields, limit = 10) => ({
    type: GET_SALESFORCE_OBJECT_PREVIEW_REQUEST,
    params: {
        connectionId,
        objectName,
        fields,
        limit
    }
});

export const getSalesforceObjectPreviewSuccess = (preview) => ({
    type: GET_SALESFORCE_OBJECT_PREVIEW_SUCCESS,
    payload: {
        preview
    }
});

export const getSalesforceObjectPreviewFailure = (error) => ({
    type: GET_SALESFORCE_OBJECT_PREVIEW_FAILURE,
    payload: {
        error
    }
});
